import '../Styles.css';
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import { Middleware, MiddlewareSuperUser } from './Middleware';
import { TokenValidateExpiration } from './Token';
import React, { useState } from 'react';
import DataTable from 'datatables.net-dt';

const token = localStorage.getItem("token");

function SuperUserCreateUserSendData() {
    document.getElementById("ChgA").style.display = "block";
    document.getElementById("BtnA").style.display = "none";
    document.getElementById("messageError").innerHTML = "";

    var email = document.getElementById("email").value;
    var rol = document.getElementById("rol").value;

    axios.post(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/super-user/user/create/'+token, {
        Email: email,
        Rol: rol,
        }, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    ).then(response => {
        window.scrollTo(0, 0);
        document.getElementById("form").style.display = "none";
        document.getElementById("messageError").style.display = "none";
        document.getElementById("ChgA").style.display = "none";
        document.getElementById("messageSuccess").style.display = "block";
        document.getElementById("messageSuccess").innerHTML = response.data.success;
        setTimeout(() => {
            window.location.href = '/super-usuario';
        }, 3000);
    })
    .catch(error => {
        window.scrollTo(0, 0);
        document.getElementById("ChgA").style.display = "none";
        document.getElementById("messageError").style.display = "block";
        document.getElementById("messageError").innerHTML = error.response.data.error;
        setTimeout(() => {
            window.location.href = '/super-usuario-crear-usuario';
        }, 3000);
    });
}

function SuperUserCreateUser() {
    Middleware();
    MiddlewareSuperUser();
    TokenValidateExpiration(token);

    var decode = jwtDecode(token);

    return (
        <div className='Container'>
            <div className='Navbar'>
                <div>
                    <h5 className='text-white'>Portal de proveedores</h5>
                </div>
            </div>
            <div className='Section'>
                <div className='Header'>
                    <div className="text-center">
                        <div className='row'>
                            <div className='col-md-6 Text-left'>
                                <label className='mt-1 Text-Gray'><b>Usuario: </b>
                                    {  
                                        decode.email
                                    }
                                </label>
                            </div>
                            <div className='col-md-6 Text-right'>
                                <a href='/logout'>
                                    <label>
                                        Cerrar sesión
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fillRule="currentColor" className="bi bi-box-arrow-right m-1" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z" />
                                            <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z" />
                                        </svg>
                                    </label>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='Article'>
                    <div className="text-center">
                        <h1 className='Text-Red'>Crear usuario</h1>
                        <br></br>
                        <br></br>
                        <div>
                            <p><i id="ChgA" className="fa fa-spinner fa-spin Chg"></i></p>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <label id='messageError' className='Error-Notification'></label>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <label id='messageSuccess' className='Success-Notification'></label>
                        </div>
                        <br></br>
                        <br></br>
                        <form id='form' action={SuperUserCreateUserSendData}>
                            <label className='text-secondary'>Correo electrónico</label>
                            <br></br>
                            <input type="text" id="email" className='Input-Style' required></input>
                            <br></br>
                            <br></br>
                            <label className='text-secondary'>Seleccionar rol</label>
                            <br></br>
                            <select className='Input-Style' id='rol' required>
                                <option></option>
                                <option value="0">Super usuario</option>
                                <option value="1">Administrador</option>
                                <option value="2">Invitador</option>
                            </select>
                            <br></br>
                            <br></br>
                            <input id='BtnA' type='submit' className='Button-Style' value="Enviar"></input>
                        </form>
                        <br></br>
                        <br></br>
                        <br></br>
                        <br></br>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SuperUserCreateUser;